var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 27.334C6.636 27.334.667 21.364.667 14S6.636.667 14 .667 27.333 6.637 27.333 14c0 7.364-5.969 13.334-13.333 13.334zM9.333 16.667v2.667h3.334V22h2.666v-2.666h1.334a3.333 3.333 0 100-6.667h-5.334a.666.666 0 110-1.333h7.334V8.667h-3.334V6h-2.666v2.667h-1.334a3.333 3.333 0 100 6.667h5.334a.667.667 0 110 1.333H9.333z",
    fill: "#529ED0"
  })));
}
export default SvgDollarLogo;